import type { ReactNode } from 'react'

import { Button } from '#/components/ui/button'
import { cn } from '#/lib/utils'
import { Link } from '@tanstack/react-router'

type ServiceCardProps = {
  variant: 'service'
  icon: ReactNode
  title: string
  description: string
  index: string
  actionLabel: string
  actionIcon?: ReactNode
  className?: string
}

export default function ServicesCard({
  className,
  icon,
  title,
  description,
  index,
  actionLabel,
  actionIcon,
}: ServiceCardProps) {
  return (
    <div
      className={cn(
        'relative flex w-full h-full flex-col items-start gap-7.5 overflow-clip rounded-[16px] bg-white p-[30px]',
        className,
      )}
    >
      <div className="flex flex-1 flex-col items-start gap-[20px]">
        <div className="flex size-17.5 items-center justify-center rounded-[999px] bg-secondary-500 p-[16px] text-white">
          <div className="text-[28px]">{icon}</div>
        </div>
        <h3 className="w-full uppercase text-[30px] font-bold leading-[normal] text-secondary-500">
          {title}
        </h3>
        <p className="w-full  text-[16px] font-normal leading-[normal] text-neutral-500">
          {description}
        </p>
        <p className="pointer-events-none absolute right-28 -top-3 translate-x-full text-[96px] font-bold leading-[normal] text-transparent opacity-[0.08]">
          {index}
        </p>
      </div>
      <Link to={`/courses`}>
        <Button
          className="h-auto gap-[10px] border-transparent bg-transparent px-[12px] py-[4px] text-[18px] text-secondary-600 shadow-none"
          variant="outline"
        >
          {actionLabel}
          <span className="text-[28px]">{actionIcon}</span>
        </Button>
      </Link>
    </div>
  )
}
